import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import {Money} from "money";
import * as JSONMapper from "json-mapper";

export class Enablement extends JSONMapped() {
	@jsonProperty()
	id: number;

	@jsonProperty()
	description: string;

	@jsonProperty()
	partKey: string;

	@jsonProperty()
	isUnredeemed: boolean;

	@jsonProperty()
	isOwned: boolean;

	@jsonProperty(JSONMapper.classByMethods(Money))
	price: Money;

	constructor(data?: Partial<Enablement>) {
		super();
		Object.assign(this, data);
	}

	get partNumber() {
		return this.partKey;
	}
}
